// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"762c8b45","415":"2e10175e","559":"0d10daa9","592":"aa5cc2ed"}[chunkId] + ".chunk.js";
};